import styled from 'styled-components';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${(props) => (props.show ? 1 : 0)};
  background-color: #e5e3c7;
  min-width: 980px;
  min-height: 551.25px;
`;

export const Slide1 = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  transition-duration: 0.3s;
  opacity: ${(props) => (props.show ? 1 : 0)};

  .slide-container {
    width: 980px;
    height: 551.25px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .detail1 {
      position: absolute;
      left: 0;
      top: 0;
      width: 774px;
      height: 551px;
      transition-duration: 0.3s;
    }

    .detail2 {
      position: absolute;
      right: 0;
      top: 0;
      width: 347px;
      height: 551px;
      transition-duration: 0.3s;
    }

    .beforeAfter {
      position: absolute;
      left: 206.42px;
      top: 200.77px;
      width: 567.16px;
      height: 319.67px;
      transition-duration: 0.3s;
    }

    h2 {
      font-size: 60px;
      font-weight: 600;
      font-family: 'poppins';
      width: 470px;
      position: absolute;
      left: 255px;
      top: 75.31px;
      color: #666335;
    }

    p {
      position: absolute;
      left: 326px;
      top: 142.51px;
      width: 328px;
      transition-duration: 0.3s;
      margin-bottom: 0;
      font-size: 24px;
      font-family: 'poppins';
      color: #666335;
    }
  }
`;
